import { useLanguage } from '../contexts/LanguageContext';
import { appShellTranslator } from '../translations/appShell';
import { getPlanStyle } from '../utils/planStyles';
import React from 'react';
import { Crown } from 'lucide-react';

export default function UserPlanBadge({ plan, displayName }) {
  const { language } = useLanguage();
  const t = appShellTranslator(language);
  if (!plan) return null;
  const code = plan.toLowerCase();
  const label = displayName || (code === 'business_trial' ? 'Business Trial' : plan.replace(/_/g, ' '));
  const standardLabel = ['Free', 'Trial', 'Free Trial', 'Business Trial'].find((value) => value.toLowerCase() === label.toLowerCase());
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize ${
    getPlanStyle(code).badge
  }`}>
    <Crown className="w-3 h-3 mr-1" aria-hidden="true" />
    {standardLabel ? t(standardLabel) : label}
  </span>;
}
